import React, { useState } from 'react';
import { HeaderContainer, StyledList, StyledListItem, StyledItemText, OutsideLink } from './Header.js';
import CustomLink from '../CustomLink/CustomLink.jsx';

import MenuIcon from '@mui/icons-material/Menu';

import Logo from '../../assets/cangoo-logo.png'

import LogoFaceOn from '../../assets/cangoo-fb-on.png'
import LogoFaceOff from '../../assets/cangoo-fb-off.png'

import LogoInstaOn from '../../assets/cangoo-ig-on.png'
import LogoInstaOff from '../../assets/cangoo-ig-off.png'

import LogoLinkedinOn from '../../assets/cangoo-ld-on.png'
import LogoLinkedinOff from '../../assets/cangoo-ld-off.png'

import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer, 
  useMediaQuery,
  useTheme,
} from '@mui/material';



export function Header() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [drawerOpen, setDrawerOpen] = useState(false);


  const [isFacebookHovered, setIsFacebookHovered] = useState(false);
  const [isInstaHovered, setIsInstaHovered] = useState(false);
  const [isLinkedinHovered, setIsLinkedinHovered] = useState(false);

  const handleWhatsappClick = () => {
    window.open('https://wa.me/554833645744', '_blank');
  };


  const handleMouseOverFace = () => {
      setIsFacebookHovered(true);
    };

  const handleMouseOutFace = () => {
      setIsFacebookHovered(false);
    };
    
  
    const handleMouseOverInsta = () => {
      setIsInstaHovered(true);
    };

    const handleMouseOutInsta = () => {
      setIsInstaHovered(false);
    };

    const handleMouseOverLinkedin = () => {
      setIsLinkedinHovered(true);
    };

    const handleMouseOutLinkedin = () => {
      setIsLinkedinHovered(false);
    };


  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };


    return (
      <>
      <HeaderContainer >
        <AppBar elevation={0} className='header'>
          <Toolbar>
           <div className="nav-container">
           
           <div className='logo'>
           <CustomLink to="/"><img id="jumping-logo" src={Logo} alt="Logo" /></CustomLink>
           </div>
          
              <div className='nav-items'>
            <ul>
            <li>
            <CustomLink to="/sobre">SOBRE NÓS</CustomLink>
            </li>

            <li>
            <CustomLink to="/faq">PERGUNTAS FREQUENTES</CustomLink>
            </li>

            <li>
            <CustomLink to="/cotacao">COTAÇÃO DE FRETE</CustomLink>
            </li>

            <li>
            <CustomLink to="/contato">CONTATO</CustomLink>
            </li>

            <li>
            <OutsideLink className='link' target="_blank" onClick={handleWhatsappClick}>RASTREIO<br/>ONLINE</OutsideLink>
            </li>

            <li>
            <OutsideLink className='link' target="_blank" href="https://cangooexpress.brudam.com.br/site/">ÁREA DO<br/>CLIENTE</OutsideLink>
            </li>

          </ul>
            </div>

           <div className='redes-sociais'>
           <OutsideLink href="https://www.facebook.com/vaidecangoo" target="_blank" onMouseOver={handleMouseOverFace} onMouseOut={handleMouseOutFace}>
              <img src={isFacebookHovered ? LogoFaceOn : LogoFaceOff} border="0" alt=''/>
            </OutsideLink>
      
            <OutsideLink href="https://www.instagram.com/vaidecangoo" target="_blank" onMouseOver={handleMouseOverInsta} onMouseOut={handleMouseOutInsta}>
              <img style={{ marginRight:'1.4rem', marginLeft: '1.4rem' }} src={isInstaHovered ? LogoInstaOn : LogoInstaOff} border="0" alt=''/>
            </OutsideLink>
      
            <OutsideLink href="https://www.linkedin.com/company/vaidecangoo" target="_blank" onMouseOver={handleMouseOverLinkedin} onMouseOut={handleMouseOutLinkedin}>
              <img src={isLinkedinHovered ? LogoLinkedinOn : LogoLinkedinOff} border="0" alt=''/>
            </OutsideLink>
           </div>
           </div>
            
            <div style={{ flex: 1 }} /> 
            {isMobile && (
              <IconButton  size='small'  sx={{ color: 'white' }} edge="end" onClick={handleDrawerOpen}>
                <MenuIcon style={{ width: '3rem', height: '3rem'}}/>
              </IconButton>
            )}
          </Toolbar>
        </AppBar>

        <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose} >
          <StyledList>
    
            <CustomLink to="/sobre">
            <StyledListItem disableGutters={true} button onClick={handleDrawerClose}><StyledItemText ><p>SOBRE NÓS</p></StyledItemText></StyledListItem>
            </CustomLink>
            <CustomLink to="/faq">
            <StyledListItem button onClick={handleDrawerClose}><StyledItemText ><p>PERGUNTAS FREQUENTES</p></StyledItemText></StyledListItem>
            </CustomLink>
            <CustomLink to="/cotacao">
            <StyledListItem button onClick={handleDrawerClose}><StyledItemText ><p>COTAÇÃO DE FRETE</p></StyledItemText></StyledListItem>
            </CustomLink>
            <CustomLink to="/contato">
            <StyledListItem button onClick={handleDrawerClose}><StyledItemText ><p>CONTATO</p></StyledItemText></StyledListItem>
            </CustomLink>

            <OutsideLink target="_blank" onClick={handleWhatsappClick}>
            <StyledListItem button onClick={handleDrawerClose}><StyledItemText ><p className='link'>RASTREIO ONLINE</p></StyledItemText></StyledListItem>
            </OutsideLink>
            <OutsideLink target="_blank" href="https://cangooexpress.brudam.com.br/site/">
            <StyledListItem button onClick={handleDrawerClose}><StyledItemText ><p className='link'>ÁREA DO CLIENTE</p></StyledItemText></StyledListItem>
            </OutsideLink>
    

            <div className='redes-sociais'>
            <OutsideLink href="https://www.facebook.com/vaidecangoo" target="_blank" onMouseOver={handleMouseOverFace} onMouseOut={handleMouseOutFace}>
              <img style={{ width: 30 }} src={isFacebookHovered ? LogoFaceOn : LogoFaceOff} border="0" alt=''/>
            </OutsideLink>
      
            <OutsideLink href="https://www.instagram.com/vaidecangoo" target="_blank" onMouseOver={handleMouseOverInsta} onMouseOut={handleMouseOutInsta}>
              <img style={{ width: 30, marginRight:'1.4rem', marginLeft: '1.4rem' }} src={isInstaHovered ? LogoInstaOn : LogoInstaOff} border="0" alt=''/>
            </OutsideLink>
      
            <OutsideLink href="https://www.linkedin.com/company/vaidecangoo" target="_blank" onMouseOver={handleMouseOverLinkedin} onMouseOut={handleMouseOutLinkedin}>
              <img style={{ width: 30 }} src={isLinkedinHovered ? LogoLinkedinOn : LogoLinkedinOff} border="0" alt=''/>
            </OutsideLink>
           </div>
           
          </StyledList>
        </Drawer>
      </HeaderContainer>

      
     
    
     </>
    )
  }